// src/lib/managers/conversation/types/const.ts

import { Tool } from "./conversation";

export const availableTools: Tool[] = [
    // Email Search Function
    {
        type: "function",
        function: {
            name: "searchMails",
            description:
                "Rechercher et effectuer des actions sur les emails selon différents critères : mots-clés, expéditeurs/destinataires, période temporelle, catégories, statuts de lecture/traitement/focus, présence de pièces jointes. Actions possibles : visualisation, suppression, marquage comme lu/non lu, focus/non focus, traité/non traité. Vous pouvez utilisez cette fonction avec analysisRequest.enabled=true si l'utilisateur souhaite obtenir des informations, analyses ou synthèses sur le contenu des emails trouvés.",
            parameters: {
                type: "object",
                properties: {
                    keywords: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                        description:
                            "Mots-clés à rechercher dans le CONTENU des emails (notamment quand l'utilisateur veut trouver des emails parlant d'un sujet, le mentionnant ou s'y rapportant). Les catégories iront dans categories (important, reponse_attendue, rappel, newsletter, informatif, suspect, autre) et non dans keywords.",
                    },
                    startDate: {
                        type: "string",
                        description:
                            "Date de début de la période de recherche (format YYYY-MM-DDTHH:mm:ssZ) - uniquement si demandé explicitement",
                    },
                    endDate: {
                        type: "string",
                        description:
                            "Date de fin de la période de recherche (format YYYY-MM-DDTHH:mm:ssZ) - uniquement si demandé explicitement",
                        // Rajouter une fin automatique sur l'année courante si, aucune spécification et présence de Start Date
                    },
                    limit: {
                        type: "number",
                        description:
                            'Nombre maximum d\'emails à récupérer. Utiliser 5 pour "derniers emails" sans nombre spécifié. Utiliser le nombre si explicite (ex: "10 derniers"). Ne PAS définir si l\'utilisateur demande "tous" ou aucune limitation.',
                        minimum: 1,
                    },
                    from: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                        description:
                            'Filtrer par expéditeur(s) : adresse(s) email ou nom(s) complet(s) (prénom nom ou nom d\'organisation ou d\'outil) des personne(s)/entité(s) QUI ONT ENVOYÉ l\'email. Utiliser pour "emails de", "provenant de", "envoyés par". Peut contenir plusieurs expéditeurs pour rechercher les emails provenant de l\'un d\'entre eux.',
                    },
                    to: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                        description:
                            'Filtrer par destinataire(s) : adresse(s) email ou nom(s) complet(s) (prénom nom ou nom d\'organisation ou d\'outil) des personne(s)/entité(s) QUI ONT REÇU l\'email. Utiliser pour "emails à", "envoyés à", "pour". Peut contenir plusieurs destinataires pour rechercher les emails envoyés à l\'un d\'entre eux.',
                    },
                    categories: {
                        type: "array",
                        items: {
                            type: "string",
                            enum: [
                                "important",
                                "reponse_attendue",
                                "rappel",
                                "newsletter",
                                "informatif",
                                // 'suspect',
                                "autre",
                            ],
                        },
                        description:
                            "La ou les catégories des mails demandés par l'utilisateur",
                    },
                    mailStatus: {
                        type: "array",
                        items: {
                            type: "string",
                            enum: [
                                "userProcessed",
                                "notUserProcessed",
                                "focus",
                                "notFocus",
                            ],
                        },
                        description:
                            "Les conditions des états des mails à rechercher (seulement si l'utilisateur le précise)",
                    },
                    readStatus: {
                        type: "string",
                        enum: ["read", "unread"],
                        description:
                            "Statut de lecture des emails (seulement si l'utilisateur le précise)",
                    },
                    hasAttachment: {
                        type: "boolean",
                        description:
                            "Filtrer les emails avec ou sans pièces jointes (seulement si l'utilisateur le précise)",
                    },
                    sortOrder: {
                        type: "string",
                        enum: ["ASC", "DESC"],
                        description:
                            "'ASC' pour les premiers emails (plus anciens), 'DESC' pour les derniers (plus récents). Par défaut 'DESC'.",
                    },
                    aiComment: {
                        type: "string",
                        description:
                            'Message personnalisé (1 phrase) pour accompagner la recherche d\'emails. Variez le ton selon le contexte : "Je recherche vos emails...", "Voici ce que j\'ai trouvé...", "Je vais analyser... les emails de...", "Je vais réaliser une synthèse..." (vouvoiement, ton professionnel mais engageant)',
                    },
                    userAction: {
                        type: "string",
                        enum: [
                            "VIEW",
                            "DELETE",
                            "MARKASREAD",
                            "MARKASUNREAD",
                            "MARKASUSERPROCESSED",
                            "MARKASUSERUNPROCESSED",
                            "MARKASFOCUS",
                            "MARKASUNFOCUS",
                        ],
                        description:
                            "L'action que souhaite réaliser l'utilisateur (Par défaut 'VIEW')",
                    },
                    analysisRequest: {
                        type: "object",
                        properties: {
                            enabled: {
                                type: "boolean",
                                description:
                                    "Déclenche l'agent d'analyse post-traitement pour traiter les résultats (true si l'utilisateur demande une synthèse, analyse, résumé, extraction d'informations spécifiques, etc.)",
                            },
                            type: {
                                type: "string",
                                enum: [
                                    "synthesis",
                                    "extraction",
                                    "analysis",
                                    "summary",
                                    "categorization",
                                    "timeline",
                                    "statistics",
                                    "comparison",
                                    "action_items",
                                    "custom",
                                ],
                                description:
                                    "Type d'analyse demandée par l'utilisateur",
                            },
                            instruction: {
                                type: "string",
                                description:
                                    "Instruction détaillée et libre pour l'agent d'analyse post-traitement (1 à 5 phrases maximum). Peut inclure toute demande d'analyse, synthèse, extraction, transformation ou traitement des données retournées. L'agent interprétera librement cette instruction pour fournir l'analyse la plus pertinente possible et s'adressera directement à l'utilisateur en utilisant le vouvoiement.",
                            },
                        },
                        required: ["enabled"],
                        description:
                            "Configuration pour déclencher l'agent d'analyse post-traitement des résultats",
                    },
                },
                required: [
                    "aiComment",
                    "userAction",
                    "sortOrder",
                    "analysisRequest",
                ],
            },
        },
    },

    // Fallback Function for Misunderstood Requests
    {
        type: "function",
        function: {
            name: "fallbackResponse",
            description:
                "Gérer les demandes incomprises ou incomplètes en fournissant une réponse d'incompréhension et des suggestions de précision.",
            parameters: {
                type: "object",
                properties: {
                    aiComment: {
                        type: "string",
                        description:
                            'Message d\'incompréhension empathique (1 phrase). Variez les formulations : "Je ne saisis pas entièrement votre demande", "Votre requête me semble incomplète", "J\'ai besoin de plus de détails", "Quelque chose m\'échappe dans votre demande" (vouvoiement, ton bienveillant)',
                    },
                    aiSuggestion: {
                        type: "string",
                        description:
                            'Suggestion constructive (1-2 phrases) pour aider l\'utilisateur à préciser sa demande. Proposez des pistes concrètes selon le contexte : "Pourriez-vous préciser...", "Il me faudrait des informations sur...", "Souhaitez-vous plutôt...", "Avez-vous en tête..." (vouvoiement, ton pédagogique et encourageant)',
                    },
                },
                required: ["aiComment", "aiSuggestion"],
            },
        },
    },

    // Basic AI Chat
    {
        type: "function",
        function: {
            name: "basicAiChat",
            description:
                "Fonction par défaut pour toute conversation générale, questions diverses, discussions libres, demandes d'aide, conseils ou sujets ne nécessitant pas les fonctionnalités spécialisées (emails, calendrier). À utiliser systématiquement pour les salutations, questions générales, demandes d'explication, conseils de productivité, ou toute interaction conversationnelle standard.",
            parameters: {
                type: "object",
                properties: {
                    aiComment: {
                        type: "string",
                        description:
                            "Réponse conversationnelle sur la gestion d'emails (maximum 4 phrases). Adaptez le style : conseils pratiques, explications simples, encouragements, partage d'astuces. Ton expert mais accessible, personnalisez selon la question posée (vouvoiement)",
                    },
                },
                required: ["aiComment"],
            },
        },
    },

    // Agenda Creation Function
    {
        type: "function",
        function: {
            name: "createAgendaItem",
            description:
                "Créer un nouvel événement dans le calendrier avec un sujet, des dates/heures de début et fin obligatoires, et optionnellement une description, un lieu et une liste de participants.",
            parameters: {
                type: "object",
                properties: {
                    subject: {
                        type: "string",
                        description: "Sujet/titre de l'événement",
                    },
                    start: {
                        type: "string",
                        description:
                            "Date et heure de début de l'événement (format YYYY-MM-DDTHH:mm:ssZ)",
                    },
                    end: {
                        type: "string",
                        description:
                            "Date et heure de fin de l'événement  (format YYYY-MM-DDTHH:mm:ssZ)",
                    },
                    description: {
                        type: "string",
                        description:
                            "Description détaillée de l'événement (optionnel)",
                    },
                    location: {
                        type: "string",
                        description: "Lieu de l'événement (optionnel)",
                    },
                    attendees: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                        description:
                            "Adresse email des attendees ou nom complet en minuscule (prénom nom)",
                    },
                    aiComment: {
                        type: "string",
                        description:
                            'Message d\'accompagnement pour la création d\'événement (1 phrase). Variez selon l\'action : "Je prépare cet événement...", "Voici le rendez-vous que je propose...", "J\'organise cette rencontre...", "Permettez-moi de planifier..." (vouvoiement, ton organisé et rassurant)',
                    },
                },
                required: ["subject", "start", "end", "aiComment"],
            },
        },
    },

    // Agenda Listing Function
    {
        type: "function",
        function: {
            name: "getAgendaItems",
            description:
                "Récupérer tous les événements du calendrier avec filtrage avancé. Gère automatiquement les demandes temporelles : 'derniers/passés' (depuis 1970 jusqu'aujourd'hui, ordre DESC) et 'prochains/futurs' (aujourd'hui + 1 an, ordre ASC). Vous pouvez utilisez cette fonction avec analysisRequest.enabled=true si l\'utilisateur souhaite obtenir des informations, analyses ou synthèses sur le contenu des évènements trouvés.",
            parameters: {
                type: "object",
                properties: {
                    startDate: {
                        type: "string",
                        description:
                            "Date de début de la période (format YYYY-MM-DDTHH:mm:ssZ). Pour les 'derniers' RDV : date actuelle - 1 an. Pour les 'prochains' : date actuelle.",
                    },
                    endDate: {
                        type: "string",
                        description:
                            "Date de fin de la période (format YYYY-MM-DDTHH:mm:ssZ). Pour les 'derniers' RDV : date actuelle. Pour les 'prochains' : date actuelle + 1 an.",
                    },
                    attendees: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                        description:
                            "Adresse email des attendees ou nom complet en minuscule (prénom nom)",
                    },
                    limit: {
                        type: "number",
                        description:
                            "Nombre maximum d'événements à retourner. Par défaut : 25.",
                    },
                    orderBy: {
                        type: "string",
                        enum: ["ASC", "DESC"],
                        description:
                            "Ordre de tri par date. 'DESC' pour les derniers événements (plus récents en premier), 'ASC' pour les prochains (plus proches en premier). Par défaut : 'ASC'.",
                    },
                    keywords: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                        description:
                            "Mots-clés à rechercher dans le titre des événements. Optionnel.",
                    },
                    aiComment: {
                        type: "string",
                        description:
                            "Message d'introduction au planning (1 phrase). Adaptez selon le contexte : 'Voici vos derniers rendez-vous...', 'Je consulte vos prochains événements...', 'Examinons votre planning récent...', 'Votre calendrier à venir indique...', \"Je vais analyser... les évènement de...\", \"Je vais réaliser une synthèse...\" (vouvoiement, ton informatif et structuré)",
                    },
                    analysisRequest: {
                        type: "object",
                        properties: {
                            enabled: {
                                type: "boolean",
                                description:
                                    "Déclenche l'agent d'analyse post-traitement pour traiter les résultats (true si l'utilisateur demande une synthèse, analyse, résumé, extraction d'informations spécifiques, etc.)",
                            },
                            type: {
                                type: "string",
                                enum: [
                                    "synthesis",
                                    "extraction",
                                    "analysis",
                                    "summary",
                                    "categorization",
                                    "timeline",
                                    "statistics",
                                    "comparison",
                                    "action_items",
                                    "custom",
                                ],
                                description:
                                    "Type d'analyse demandée par l'utilisateur",
                            },
                            instruction: {
                                type: "string",
                                description:
                                    "Instruction détaillée et libre pour l'agent d'analyse post-traitement (1 à 5 phrases maximum). Peut inclure toute demande d'analyse, synthèse, extraction, transformation ou traitement des données retournées. L'agent interprétera librement cette instruction pour fournir l'analyse la plus pertinente possible et s'adressera directement à l'utilisateur en utilisant le vouvoiement.",
                            },
                        },
                        required: ["enabled"],
                        description:
                            "Configuration pour déclencher l'agent d'analyse post-traitement des résultats",
                    },
                },
                required: [
                    "startDate",
                    "endDate",
                    "aiComment",
                    "analysisRequest",
                ],
            },
        },
    },

    // Free Time Slots Search Function
    {
        type: "function",
        function: {
            name: "findFreeTimeSlots",
            description:
                "Identifier les créneaux libres dans l'agenda pour une période donnée en spécifiant la durée minimum souhaitée des créneaux disponibles.",
            parameters: {
                type: "object",
                properties: {
                    startDate: {
                        type: "string",
                        description:
                            "Date de début de la recherche (format YYYY-MM-DDTHH:mm:ssZ)",
                    },
                    endDate: {
                        type: "string",
                        description:
                            "Date de fin de la recherche (format YYYY-MM-DDTHH:mm:ssZ)",
                    },
                    minutesToAllocate: {
                        type: "number",
                        description:
                            "Durée minimum des créneaux recherchés en minutes",
                        minimum: 1,
                    },
                    aiComment: {
                        type: "string",
                        description:
                            'Message d\'accompagnement pour la recherche de créneaux (1 phrase). Variez l\'approche : "J\'identifie vos moments libres...", "Analysons vos disponibilités...", "Je scrute votre agenda...", "Cherchons des créneaux disponibles..." (vouvoiement, ton méthodique et serviable)',
                    },
                },
                required: [
                    "startDate",
                    "endDate",
                    "minutesToAllocate",
                    "aiComment",
                ],
            },
        },
    },
    {
        type: "function",
        function: {
            name: "suggestAvailableTools",
            description:
                "Proposer à l'utilisateur une liste des fonctionnalités disponibles avec leurs descriptions pour l'aider à formuler sa demande.",
            parameters: {
                type: "object",
                properties: {
                    aiComment: {
                        type: "string",
                        description:
                            'Message d\'aide proactive (1 phrase). Montrez votre polyvalence : "Je peux vous accompagner de plusieurs façons...", "Mes compétences couvrent différents domaines...", "Voici comment je peux vous être utile...", "Laissez-moi vous présenter mes services..." (vouvoiement, ton serviable et professionnel)',
                    },
                    availableToolNames: {
                        type: "array",
                        items: {
                            type: "string",
                            enum: [
                                "searchMails",
                                "basicAiChat",
                                "createAgendaItem",
                                "getAgendaItems",
                                "findFreeTimeSlots",
                            ],
                        },
                        description:
                            "Liste des noms des outils/méthodes à suggérer à l'utilisateur",
                    },
                },
                required: ["aiComment", "availableToolNames"],
            },
        },
    },
];

export const analysisAgentTools: Tool[] = [
    {
        type: "function",
        function: {
            name: "analysisAgentOutput",
            description:
                "Tool utilisée exclusivement par l'agent d'analyse post-traitement pour communiquer directement avec l'utilisateur après avoir traité les données brutes retournées par les autres outils.",
            parameters: {
                type: "object",
                properties: {
                    analysisResult: {
                        type: "string",
                        description:
                            "Résultat complet de l'analyse effectuée par l'agent d'analyse. Cette réponse doit être rédigée en s'adressant directement à l'utilisateur avec le vouvoiement, dans un ton professionnel et engageant.",
                    },
                },
                required: ["analysisResult"],
            },
        },
    },
];

export const toolDescriptions = {
    searchMails: [
        "Je peux rechercher vos emails selon différents critères comme des mots-clés, expéditeurs, dates, catégories ou statuts, et effectuer des actions dessus comme les consulter, supprimer, marquer comme lus ou les organiser",
        "Je suis capable de filtrer vos messages électroniques par contenu, personnes, périodes ou types, puis de les afficher, les gérer ou modifier leur état selon vos besoins",
        "Je peux fouiller dans votre boîte mail pour trouver des emails spécifiques en utilisant divers filtres, et ensuite les traiter comme vous le souhaitez",
        "Je vous aide à localiser des emails précis dans votre messagerie grâce à plusieurs options de recherche, et à les organiser ou les modifier par la suite",
        "Je peux explorer votre courrier électronique selon vos critères de recherche et réaliser les actions que vous demandez sur les messages trouvés",
    ],

    basicAiChat: [
        "Je peux vous conseiller sur la gestion de votre messagerie et vous expliquer comment mieux organiser vos emails au quotidien",
        "Je vous aide à comprendre les bonnes pratiques pour trier, classer et traiter efficacement votre courrier électronique",
        "Je peux vous donner des astuces pour optimiser votre utilisation de la boîte mail et améliorer votre productivité",
        "Je vous accompagne avec des conseils personnalisés sur la façon de gérer votre flux d'emails et votre agenda",
        "Je peux discuter avec vous de stratégies pour mieux organiser votre communication électronique et votre planning",
    ],

    createAgendaItem: [
        "Je peux créer de nouveaux événements dans votre calendrier en définissant le titre, les dates, heures, et optionnellement la description, le lieu et les participants",
        "Je vous aide à planifier de nouveaux rendez-vous dans votre agenda avec tous les détails nécessaires comme l'horaire, l'endroit et les personnes concernées",
        "Je peux ajouter des événements à votre planning en précisant quand cela se passe, de quoi il s'agit, et qui y participe si besoin",
        "Je suis capable d'organiser votre emploi du temps en créant de nouvelles activités avec leurs informations complètes dans votre calendrier",
        "Je peux programmer de nouveaux créneaux dans votre agenda en y ajoutant toutes les informations utiles comme l'heure, le sujet et le lieu",
    ],

    getAgendaItems: [
        "Je peux consulter et vous présenter tous vos événements prévus sur une période que vous définissez dans votre calendrier",
        "Je vous aide à visualiser votre planning en récupérant tous vos rendez-vous programmés pour les dates qui vous intéressent",
        "Je peux afficher votre emploi du temps complet sur la période de votre choix pour que vous ayez une vue d'ensemble",
        "Je suis capable de lister tous vos événements planifiés entre deux dates pour vous donner un aperçu de votre agenda",
        "Je peux vous montrer ce que vous avez de prévu dans votre calendrier sur les jours ou semaines que vous souhaitez voir",
    ],

    findFreeTimeSlots: [
        "Je peux identifier les moments libres dans votre planning sur une période donnée en précisant la durée minimum dont vous avez besoin",
        "Je vous aide à trouver des créneaux disponibles dans votre agenda en cherchant des plages horaires suffisamment longues pour vos besoins",
        "Je peux repérer les trous dans votre emploi du temps où vous pourriez caser une nouvelle activité d'une durée spécifique",
        "Je suis capable de détecter quand vous êtes libre dans votre calendrier en tenant compte du temps nécessaire pour ce que vous voulez planifier",
        "Je peux analyser votre planning pour vous proposer des moments où vous n'avez rien de prévu et qui durent assez longtemps",
    ],
};
